import { FC } from 'react';
import Box from 'yoda-ui/components/Box';
import Tag from 'yoda-ui/components/Tags/Tag';
import { SxProps, YodaBorderRadius, YodaColors, YodaFontSize, YodaFontWeight, YodaSpacing } from 'yoda-ui/yodaTheme';

type InfoTagProps = {
  title: string;
  field?: string;
  sx?: SxProps;
};

const InfoTag: FC<InfoTagProps> = ({ title, field, sx }) => (
  <Box marginBottom={ YodaSpacing.medium } sx={ sx }>
    <Box
      marginBottom={ YodaSpacing.xxSmall }
      fontWeight={ '600' }
      color={ YodaColors.textPrimary }
      fontSize={ YodaFontSize.small }
    >
      { title }
    </Box>
    <Tag
      bgcolor={ YodaColors.gray1 }
      color={ YodaColors.textSecondary }
      borderColor={ '#AFBACB' }
      fontWeight={ YodaFontWeight.regular }
      minHeight={ '21px' }
      borderRadius={ YodaBorderRadius.small }
      border={ true }
      fontSize={ YodaFontSize.medium }
      paddingX={ YodaSpacing.xSmall }
      paddingY={ '11px' }
    >
      { field }
    </Tag>
  </Box>
);

export default InfoTag;
